import { render, staticRenderFns } from "./AppUserTeamFantasyModal.vue?vue&type=template&id=daca6ae4&"
import script from "./AppUserTeamFantasyModal.vue?vue&type=script&lang=js&"
export * from "./AppUserTeamFantasyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports